import _ from 'lodash';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import winnersViewComponents from '@/components/game-winners/_components';

@Component({
  name: 'GameWinnersComponent',
  components: winnersViewComponents
})
export default class GameWinnersComponent extends TombolaBaseComponent {
  @Prop() public gameName: string;
  private gameWinnersComponentName: string = '';

  private async mounted() {
    const componentName = `${_.camelCase(this.gameName)}WinnersView`;
    this.gameWinnersComponentName = this.$options.components[componentName] ? componentName : 'baseWinnersView';
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game-winners/game-winners.component.ts